import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";
import "./UtmParameterSelect.css"; // ✅ Import the CSS file

const formatGroupLabel = (data) => (
  <div className="group-label">
    <span>{data.label}</span>
    <span className="group-badge">{data.options.length}</span>
  </div>
);

const formatOptionLabel = (data) => (
  <div className="group-label">
    <span>{data.label}</span>
  </div>
);

const UtmParameterSelect = observer(({ store, field, utmStore, isDisabled = false }) => {
  return (
    <Select
      sm={10}
      className="react-select-container"
      classNamePrefix="react-select"
      options={store?.optionValues()}
      id={`selected-${field}`}
      value={utmStore?.utmParametersConfigs[`${field}SelectValue`] || null}
      onInputChange={(data) => store?.search(data)}
      onChange={(data) => {
        utmStore?.updateSelectValue(field, data); // ✅ Update the corresponding select value in `Utm`
      }}
      formatGroupLabel={formatGroupLabel}
      formatOptionLabel={formatOptionLabel}
      placeholder="Select"
      isDisabled={isDisabled}
    />
  );
});

export default UtmParameterSelect;
